{
  "version": "v4.3.0",
  "name": "Position",
  "bytecode": "0a0819402c410e413141d741f84276428a01000001010ece007a494d470d13216217000c0d160001350201000000020ace007a494d470d132162ce01020000030901408d160016010c0d3687170316001601371704160316043616031604314c020d4a010c36170516050c2f4c04160416022d02160216053313415f7b160016011602871706160516061604334c020d4a010c361705160416063617040c1602361602381707160216072d1702160416072d17040c16073616072d0d351707160416051607373917040f1602370e3a170816080e16021608373637170816080e16021608373637170816080e16021608373637170816080e16021608373637170816080e16021608373637170816080e16021608373637170816041608370200000304011216001601160200021703160016011602870c334c0416030d2a0216030201000409034062d379a1c203b4ce00451343857ba0003f16001f3d17040c0c0c1707170617050c170816080f314c403ea0000c334c403516087a0f314d0d2a7816087a0f314d0d2ac32ba00013cd0100000000000000000000000000000000000216087a0f314d112a7916087a0f314d102ac316087a0f314d112a782a16087a0f314d102ac416080d2a17084a7fbe160116021603a103a102a1011604a1001605160616070201000202000ed3b478489ab4ce00451343857ba00416002aa104a00516012aa10501000308034056d3ad05a194b4ce00451343857b0c0c0c1705170417030c170616060f314c404016067a0f314d7816067a0f314d102ac3334c0916067a0f314d102ac34a0616067a0f314d781707160716067a0f314d0f2a7916067a0f314d102ac316072b16067a0f314d102ac416060d2a17064a7fbc16031604160502010000000406d3f97c255fa000a001a002a00302",
  "codeHash": "893257ca0a6b91cb3976f1cdb74a6b56f8a9f0d54a8034e22e8281dd33c6f313",
  "fieldsSig": {
    "names": [
      "parent",
      "nftIndex",
      "liquidity",
      "growthsInside",
      "tokensOwed",
      "__stdInterfaceId"
    ],
    "types": [
      "Address",
      "U256",
      "U256",
      "[U256;3]",
      "[U256;3]",
      "ByteVec"
    ],
    "isMutable": [
      false,
      false,
      true,
      true,
      true,
      false
    ]
  },
  "eventsSig": [],
  "functions": [
    {
      "name": "getTokenUri",
      "paramNames": [],
      "paramTypes": [],
      "paramIsMutable": [],
      "returnTypes": [
        "ByteVec"
      ]
    },
    {
      "name": "getCollectionIndex",
      "paramNames": [],
      "paramTypes": [],
      "paramIsMutable": [],
      "returnTypes": [
        "ByteVec",
        "U256"
      ]
    },
    {
      "name": "mulDiv",
      "paramNames": [
        "a",
        "b",
        "denominator"
      ],
      "paramTypes": [
        "U256",
        "U256",
        "U256"
      ],
      "paramIsMutable": [
        false,
        false,
        true
      ],
      "returnTypes": [
        "U256"
      ]
    },
    {
      "name": "mulDivRoundingUp",
      "paramNames": [
        "a",
        "b",
        "denominator"
      ],
      "paramTypes": [
        "U256",
        "U256",
        "U256"
      ],
      "paramIsMutable": [
        false,
        false,
        false
      ],
      "returnTypes": [
        "U256"
      ]
    },
    {
      "name": "update",
      "paramNames": [
        "liquidityDelta",
        "growths"
      ],
      "paramTypes": [
        "I256",
        "[U256;3]"
      ],
      "paramIsMutable": [
        false,
        false
      ],
      "returnTypes": [
        "[U256;3]"
      ]
    },
    {
      "name": "deposit",
      "paramNames": [
        "amount0",
        "amount1"
      ],
      "paramTypes": [
        "U256",
        "U256"
      ],
      "paramIsMutable": [
        false,
        false
      ],
      "returnTypes": []
    },
    {
      "name": "collect",
      "paramNames": [
        "maxAmounts"
      ],
      "paramTypes": [
        "[U256;3]"
      ],
      "paramIsMutable": [
        false
      ],
      "returnTypes": [
        "[U256;3]"
      ]
    },
    {
      "name": "getState",
      "paramNames": [],
      "paramTypes": [],
      "paramIsMutable": [],
      "returnTypes": [
        "U256",
        "[U256;3]"
      ]
    }
  ],
  "constants": [],
  "enums": [
    {
      "name": "FullMathError",
      "fields": [
        {
          "name": "MulDivOverflow",
          "value": {
            "type": "U256",
            "value": "351"
          }
        }
      ]
    },
    {
      "name": "PositionError",
      "fields": [
        {
          "name": "NotParent",
          "value": {
            "type": "U256",
            "value": "901"
          }
        }
      ]
    }
  ],
  "stdInterfaceId": "0003"
}